/*eslint-disable */
var $ = window.jQuery = require('jquery')

import {
  bus
} from '@/main';
import carousel from 'vue-owl-carousel'
import {
mapGetters,
} from 'vuex';
import pdfViewer from './pdf-viewer';

export default {
  name: 'vista-public-media-list',
  components: {
    carousel,
    'pdf-viewer' : pdfViewer
  },
  props: [],
  data () {
    return {
      popularVideosData:null,
      popularVideosResults:[],
      ashrayPdfURl:"https://lymphomap-chatbot-data.s3.ap-south-1.amazonaws.com/Welcoming_Ashray_-_The_Warriors_of_Lymphoma.pdf",
      ashrayPdfName:'Welcoming Ashray The Warriors of Lymphoma',
      jscapPdfURl:"https://lymphomap-chatbot-data.s3.ap-south-1.amazonaws.com/Lymphomap+x+JASCAP+Webinar+Flyer+-+OFFICIAL.pdf",
      jscapPdfName:'Global Lymphoma Awareness Week: Demystifying Lymphoma',
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfViewerFileName:''
    }
  },
  computed: {
    ...mapGetters([
      'getVistaPublicMediaListState'
    ]),
    getVistaPublicMediaListFun(){
      this.popularVideosData = this.$store.getters.getVistaPublicMediaListState;
      return
    },
    setIntialStateOfMedia(){
      if(this.popularVideosData){
        this.popularVideosResults = this.popularVideosData.data 
      }
    }
  },
  mounted () {
    this.getVistaPublicMediaListFun
    this.setIntialStateOfMedia
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
  },
  methods: {
    pdfViewerFun(url, fileName){
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
  },
  watch:{
    getVistaPublicMediaListFun(){
      return this.$store.getters.getVistaPublicMediaListState
    },
    setIntialStateOfMedia(){
      if(this.popularVideosData){
        this.popularVideosResults = this.popularVideosData.items 
      }
    }
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}